import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57cd7304"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "questionBox",
  id: "app"
}
const _hoisted_3 = { class: "questionContainer" }
const _hoisted_4 = { class: "title is-6" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 512 512"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16 64v384h480V64Zm448 32v144H48V96ZM48 416V272h416v144Z"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 512 512"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16 64v384h480V64Zm304 32v320H192V96ZM48 96h112v320H48Zm416 320H352V96h112Z"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "nav-dots" }
const _hoisted_13 = { class: "flex flex-row justify-center items-center w-2/5" }
const _hoisted_14 = { class: "flex flex-col w-full p-2" }
const _hoisted_15 = {
  class: "w-full max-w-xs flex flex-col py-5 px-8",
  action: ""
}
const _hoisted_16 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_17 = ["disabled", "placeholder"]
const _hoisted_18 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_19 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_20 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_21 = { class: "flex flex-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-700 font-bold py-2",
  for: ""
}, "BPM", -1))
const _hoisted_23 = { class: "flex flex-col w-2/5 p-2" }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-row justify-center items-center",
  style: {"width":"500em"}
}
const _hoisted_25 = { class: "flex flex-col w-full p-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/jp.svg"
  }),
  /*#__PURE__*/_createTextVNode(" Kanji")
], -1))
const _hoisted_27 = { class: "flex flex-col w-full p-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/jp.svg"
  }),
  /*#__PURE__*/_createTextVNode("Romaji")
], -1))
const _hoisted_29 = { class: "flex flex-col w-full p-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/us.svg"
  }),
  /*#__PURE__*/_createTextVNode("English")
], -1))
const _hoisted_31 = { class: "flex flex-col w-full p-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/es.svg"
  }),
  /*#__PURE__*/_createTextVNode("Spanish")
], -1))
const _hoisted_33 = { class: "flex flex-col w-full p-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/pt.svg"
  }),
  /*#__PURE__*/_createTextVNode("Portuguese")
], -1))
const _hoisted_35 = { class: "flex flex-col w-full p-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/ko.svg"
  }),
  /*#__PURE__*/_createTextVNode("Korean")
], -1))
const _hoisted_37 = { class: "flex flex-col w-full p-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/ru.svg"
  }),
  /*#__PURE__*/_createTextVNode("Russian")
], -1))
const _hoisted_39 = { class: "flex flex-col w-full p-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/it.svg"
  }),
  /*#__PURE__*/_createTextVNode("Italian")
], -1))
const _hoisted_41 = { class: "flex flex-col w-full p-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/fr.svg"
  }),
  /*#__PURE__*/_createTextVNode("French")
], -1))
const _hoisted_43 = { class: "flex flex-col w-full p-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/de.svg"
  }),
  /*#__PURE__*/_createTextVNode("German")
], -1))
const _hoisted_45 = { class: "flex flex-col w-full p-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/in.svg"
  }),
  /*#__PURE__*/_createTextVNode("Indonesian")
], -1))
const _hoisted_47 = { class: "flex flex-col w-full p-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "flex content-center justify-start items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-7",
    src: "/flags/hi.svg"
  }),
  /*#__PURE__*/_createTextVNode("Hindi")
], -1))
const _hoisted_49 = {
  key: 1,
  class: "flex flex-col flex-wrap content-around w-full p-2"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/jp.svg"
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/jp.svg"
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/us.svg"
}, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/es.svg"
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/pt.svg"
}, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/ko.svg"
}, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/ru.svg"
}, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/it.svg"
}, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/fr.svg"
}, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/de.svg"
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7",
  src: "/flags/hi.svg"
}, null, -1))
const _hoisted_61 = { class: "questionFooter" }
const _hoisted_62 = {
  class: "pagination flex justify-between",
  role: "navigation",
  "aria-label": "pagination"
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YouTube = _resolveComponent("YouTube")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, {
    modelValue: _ctx.showModal,
    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showModal) = $event)),
    classes: "flex justify-center items-center",
    "content-class": "relative w-5/6 h-5/6 flex flex-col max-h-full mx-4 p-4 border dark:border-gray-800 rounded bg-white dark:bg-gray-900 overflow-scroll"
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            "enter-active-class": "animated zoomIn",
            "leave-active-class": "animated zoomOut",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("header", null, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.actions_add_lyric), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleViewMode && _ctx.toggleViewMode(...args)))
                    }, [
                      (_ctx.viewMode == 'rows')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    "data-slide": "1",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 0}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "2",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 1}])
                  }, null, 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["page hidden", {'page_active': _ctx.currentStep == 0}])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("form", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.labels_youtube_video_url), 1),
                        _withDirectives(_createElementVNode("input", {
                          class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
                          type: "text",
                          disabled: _ctx.isLoadingVideoInfo,
                          placeholder: _ctx.labels_input_youtube_url_placeholder,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerdata.videoUrl) = $event)),
                          onKeyup: _cache[2] || (_cache[2] = ({ target: { value } }) => _ctx.debounce(value)),
                          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getVideoInfo && _ctx.getVideoInfo(...args)))
                        }, null, 40, _hoisted_17), [
                          [_vModelText, _ctx.registerdata.videoUrl]
                        ]),
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.labels_song_title), 1),
                        _withDirectives(_createElementVNode("input", {
                          class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
                          type: "text",
                          placeholder: "",
                          disabled: "",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.verses.songTitle) = $event)),
                          onKeyup: _cache[5] || (_cache[5] = ({ target: { value } }) => _ctx.debounce(value))
                        }, null, 544), [
                          [_vModelText, _ctx.verses.songTitle]
                        ]),
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.labels_band_name), 1),
                        _withDirectives(_createElementVNode("input", {
                          class: "text-gray-700 shadow border rounded border-gray-300 mb-3 py-1 px-3 focus:outline-none focus:shadow-outline",
                          type: "text",
                          placeholder: "",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.verses.animeName) = $event)),
                          onKeyup: _cache[7] || (_cache[7] = ({ target: { value } }) => _ctx.debounce(value))
                        }, null, 544), [
                          [_vModelText, _ctx.verses.animeName]
                        ]),
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.labels_youtube_video_id), 1),
                        _withDirectives(_createElementVNode("input", {
                          class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
                          type: "text",
                          placeholder: "",
                          disabled: "",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registerdata.videoId) = $event)),
                          onKeyup: _cache[9] || (_cache[9] = ({ target: { value } }) => _ctx.debounce(value))
                        }, null, 544), [
                          [_vModelText, _ctx.registerdata.videoId]
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("button", {
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.tapBpm && _ctx.tapBpm(...args)))
                          }, "Tempo"),
                          _createElementVNode("p", null, _toDisplayString(_ctx.registerdata.bpm), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_YouTube, {
                        id: "player",
                        class: "video-foreground",
                        style: {"position":"absolute","z-index":"10","width":"auto","min-width":"100%","min-height":"100%","max-width":"none"},
                        width: "auto",
                        height: "100%",
                        "min-width": "100%",
                        "min-height": "100%",
                        "max-width": "none",
                        src: 'https://www.youtube.com/watch?v=' + _ctx.registerdata.videoId,
                        vars: _ctx.playerVars,
                        host: "localhost:8080",
                        ref: "player"
                      }, null, 8, ["src", "vars"])
                    ])
                  ]),
                  (_ctx.viewMode == 'sidebyside')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.kanjiVerses) = $event)),
                            rows: "40",
                            col: "90"
                          }, null, 512), [
                            [_vModelText, _ctx.kanjiVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.romajiVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.romajiVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.englishVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.englishVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.spanishVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.spanishVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.portugueseVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.portugueseVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.koreanVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.koreanVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.russianVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.russianVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.italianVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.italianVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.frenchVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.frenchVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.germanVerses) = $event)),
                            rows: "40",
                            col: "110"
                          }, null, 512), [
                            [_vModelText, _ctx.germanVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.indonesianVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.indonesianVerses]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.hindiVerses) = $event)),
                            rows: "40",
                            col: "100"
                          }, null, 512), [
                            [_vModelText, _ctx.hindiVerses]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewMode == 'rows')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: line.id,
                            class: "p-4 border-dotted border-2 border-gray-200"
                          }, [
                            _createElementVNode("div", null, [
                              _hoisted_50,
                              _createTextVNode(" " + _toDisplayString(line.text), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_51,
                              _createTextVNode(" " + _toDisplayString(line.romaji), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_52,
                              _createTextVNode(" " + _toDisplayString(line.en), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_53,
                              _createTextVNode(" " + _toDisplayString(line.es), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_54,
                              _createTextVNode(" " + _toDisplayString(line.portuguese), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_55,
                              _createTextVNode(" " + _toDisplayString(line.korean), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_56,
                              _createTextVNode(" " + _toDisplayString(line.russian), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_57,
                              _createTextVNode(" " + _toDisplayString(line.italian), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_58,
                              _createTextVNode(" " + _toDisplayString(line.french), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_59,
                              _createTextVNode(" " + _toDisplayString(line.german), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_60,
                              _createTextVNode(" " + _toDisplayString(line.hindi), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("footer", _hoisted_61, [
                  _createElementVNode("nav", _hoisted_62, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary button order-first",
                      onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                    }, _toDisplayString(_ctx.actions_cancel), 1),
                    _createElementVNode("button", {
                      class: "btn button order-last",
                      disabled: _ctx.verifyingVideoExists || _ctx.videoExists,
                      onClick: _cache[24] || (_cache[24] = async (e)=> {await _ctx.nextStep()})
                    }, [
                      (_ctx.currentStep == 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.actions_continue), 1)
                          ], 64))
                        : (_ctx.currentStep == 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.isSaving)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.actions_save), 1)
                                  ], 64))
                            ], 64))
                          : _createCommentVNode("", true)
                    ], 8, _hoisted_63)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}